import { render, staticRenderFns } from "./entrustManager.vue?vue&type=template&id=79584b60&scoped=true&"
import script from "./entrustManager.vue?vue&type=script&lang=js&"
export * from "./entrustManager.vue?vue&type=script&lang=js&"
import style0 from "./entrustManager.vue?vue&type=style&index=0&id=79584b60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79584b60",
  null
  
)

export default component.exports